const usdMapping: { [stars: number]: number | undefined } = {
    50: 0.99,
    75: 1.49,
    100: 1.99,
    150: 2.99,
    250: 4.99,
    350: 6.99,
    500: 9.99,
    750: 14.99,
    1000: 19.99,
    1500: 29.99,
    2500: 49.99,
};

const processorFeeMapping: { [stars: number]: number | undefined } = {
    50: 0.3 + 0.04,
    75: 0.45 + 0.07,
    100: 0.6 + 0.09,
    150: 0.9 + 0.14,
    250: 1.5 + 0.24,
    350: 2.1 + 0.34,
    500: 3 + 0.49,
    750: 4.5 + 0.74,
    1000: 6 + 0.99,
    1500: 9 + 1.49,
    2500: 15 + 2.49,
};

/** @see https://core.telegram.org/bots/payments-stars#star-pricing */
export function convertToUSD(stars: number): number {
    // Look up an exact conversion:
    if (usdMapping[stars]) {
        return usdMapping[stars];
    }

    // Fall back to an approximate conversion:
    return stars / 50.05005;
}

/** @see https://core.telegram.org/bots/payments-stars#star-pricing */
export function getProcessorFeeUSD(stars: number): number {
    // Look up an exact processor fee:
    if (processorFeeMapping[stars]) {
        return processorFeeMapping[stars];
    }

    // Fall back to an approximate processor fee:
    const approximateAppStoreFee = 0.3 * stars;
    const approximateTelegramFee = 0.00099 * stars;
    return approximateAppStoreFee + approximateTelegramFee;
}
